import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./Style/index.scss";
import "./fonts/fonts.scss";
import Loading from "./components/Loading";

const root = ReactDOM.createRoot(document.getElementById("root"));
const rootLoader = ReactDOM.createRoot(document.getElementById("root-loader"));
rootLoader.render(<Loading />);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
